<template>
  <!--/*<Loading>は入れない。画面全体読み込みになるのでくるくる表示してもロジックが複雑になるだけなので*/-->
  <div v-if="notFound" style="padding:40px">プロジェクトが見つかりませんでした</div>
  <div v-if="publicPageData" class="projectTop" :style="{'background':viewLayoutRequest && viewLayoutRequest.bodyBackGround}">
    <PublicPagePlain 
      v-if="publicPageData.layout === PublicPageLayout.PLAIN"
      ref="empty"
      :kiwiIframeURL="kiwiIframeURL"
      :publicPageData="publicPageData"
      :publicPageTitle="getPublicPageTitle()"
      :projectUserName="getPublicPageUserName()"
      :viewLayoutRequest="viewLayoutRequest"
    />
    <PublicPageStandard 
      v-else 
      ref="standard"
      :kiwiIframeURL="kiwiIframeURL"
      :publicPageData="publicPageData" 
      :isPreview="isPreview" 
      :publicPageTitle="getPublicPageTitle()" 
      :projectUserName="getPublicPageUserName()" 
      :viewLayoutRequest="viewLayoutRequest"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import RootVue from "@/RootVue.vue";
import PublicPagePlain from "@/pages/publicPage/PublicPagePlain.vue";
import PublicPageStandard from "@/pages/publicPage/PublicPageStandard.vue";
import PublicPageResp from '@/interface/api/PublicPageResp'
import { PublicPageLayout, PublicPageLayoutEnum } from '@/interface/PublicPageLayout';
import routeState from "@/state/RouteState";
import common from '@/common';
import { PublicPageLayoutSize, PublicPageLayoutSizeEnum } from '@/types/PublicPageLayoutSize';
import { FMScrollTo, ForkstyleMessages, FMRequestLogin, FMSetLayout, FMEventListenerAdded } from '@/interface/kiwi/ForkstyleMessage';
import PublicPageVue from '@/pages/publicPage/_interface/PublicPageVue';
import { ForkstyleCommandSize } from '@/interface/kiwi/ForkstyleCommand';
import FunctionLauncher from '@/logic/FunctionLauncher';
import ScrollDetector from '@/logic/ScrollDetector';
import {startWakeLock, endWakeLock} from '@/logic/ScreenLock';
import urls from "@/URLs";
import {registerEventSend, clearEventSend} from "@/interface/kiwi/eventSender";


@Options({ 
  components: {
    PublicPagePlain,
    PublicPageStandard,
  }
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  //mounted前のlifesycleだと初期化されていないので使用できない点に注意
  @Ref() readonly empty = null as any as PublicPagePlain;
  @Ref() readonly standard = null as any as PublicPageStandard;
  readonly urls = urls;
    
  publicPageData: PublicPageResp = null as any;
  viewLayoutRequest = null as null|FMSetLayout;
  PublicPageLayout = PublicPageLayout;
  PublicPageLayoutSize = PublicPageLayoutSize;
  notFound = false
  afterLoadLauncher = new FunctionLauncher(["PROJECT LOADED"])

  prevWidth = 0;
  prevHeight = 0;
  sizeRequestedCount = 0
  scrollDetector = new ScrollDetector();

  get isPreview(){
    return !!(this.$route.query?.preview)
  }

  get isLoading(){
    return this.publicPageData === null && !this.notFound
  }
  
  get kiwiIframeURL() {
    return this.urls.getKiwiViewURL(
      this.getPublicPageUserName(),
      this.publicPageData.baseProjectId,
      this.publicPageData.htmlPath,
      true,
      false,
      this.publicPageData.layoutSize !== PublicPageLayoutSize.FIXED_SIZE
    );
  }

  getPublicPageTitle() {
    return this.$route.params.publicPageTitle as string;
  }
  getPublicPageUserName() {
    return this.$route.params.userName as string;
  }

  countUpVisited(){
    this.$root.restAccess.countUpVisited(this.publicPageData.id);
  }

  showPreview() {
    if(!this.$root.account.isLogin){
      if(this.$root.account.isLoaded){
        //未ログイン、アカウント読込済みであればプレビュー表示しない
        this.notFound = true
      }else{
        //未ログイン、アカウント未読込の場合、アカウント読込後に実行する
        this.$root.account.addLoginListener(this.showPreview)
      }
      return
    }
    
    const publicPageData = {...this.$route.query} as any as PublicPageResp
    publicPageData.layout = parseInt(publicPageData.layout as any) as PublicPageLayoutEnum; //URL経由で渡すので文字化されるため
    publicPageData.layoutSize = parseInt(publicPageData.layoutSize as any) as PublicPageLayoutSizeEnum;
    publicPageData.layoutSizeX = common.customParseInt(publicPageData.layoutSizeX as any) //URL経由で渡すので文字化されるため
    publicPageData.layoutSizeY = common.customParseInt(publicPageData.layoutSizeY as any) //URL経由で渡すので文字化されるため
    publicPageData.layoutZoom = (publicPageData.layoutZoom as any === 'true');
    publicPageData.layoutBorder = (publicPageData.layoutBorder as any === 'true');
    publicPageData.viewCount = 0
    publicPageData.goodCount = 0
    publicPageData.commentsCount = 0
    publicPageData.anonymousGoodCount = 0
    publicPageData.hasLoginUserGood = false
    publicPageData.user = this.$root.account.info as any
    this.initPublicPage(publicPageData);
  }

  showPublicPage(){
    let publicPage = routeState.recievePublicPageFromPreviousPage()

    //前画面でプロジェクト情報を持っているケースが多いはずなので、再読み込みせずに直接表示する。
    //ここは最も使う画面の一つのハズなので、軽量性を優先。
    if(publicPage){
      if (process.env.VUE_APP_MODE === "development")console.log("前画面から渡されたプロジェクトをそのまま表示", publicPage);
      this.initPublicPage(publicPage);
    }else{
      this.$root.restAccess.getPublicPage(this.getPublicPageUserName(), this.getPublicPageTitle()).then((resp: Response) => {
        if(resp.ok){
          resp.json().then(json => {
            this.initPublicPage(new PublicPageResp(json));
          })
        }else{
          this.notFound = true
        }
      });
    }
  }

  requestSize(){
    this.afterLoadLauncher.runFunction(()=>{
      //404の時は実行しない
      if(this.notFound){
        return;
      }

      if(this.scrollDetector.isScrolling()){
        this.scrollDetector.setCallBackOnScrollEnd(this.requestSize);
        return;
      }

      const w = this.$root.common.getWindowWidth();
      const h = this.$root.common.getWindowHeight();

      //スマホ表示でスクロールした時に何故かresizeイベントが呼ばれてしまう対策
      if(this.prevWidth === w
      && this.prevHeight === h){
        return;
      }
      this.prevWidth = w;
      this.prevHeight = h;
      

      const child = this.getChildVueComponent();
      //projectページ->他ページと画面遷移する瞬間に、サイズ変更すると、getChildVueComponent()がnullになる。
      if(!child){
        if (process.env.VUE_APP_MODE === "development")console.log("公開ページ破棄後にサイズ変更されました");
        return;
      }


      ++this.sizeRequestedCount;
      if(this.sizeRequestedCount === 1){
        //windowサイズが変更された時にiframeに高さが指定されていると、iframe子側でも正確にスクロールサイズが計算されなくなる。
        //このためサイズをクリアした状態でサイズ送信を要求する（親側起点とする）
        child.clearIframeSize();
        (child.getIframe())?.contentWindow?.postMessage({ type: "forkstyle-command-size"} as ForkstyleCommandSize, "*");
      }
    })
  }

  nowScrolling(){
    //this.scrollDetector.nowScrolling自体をaddEventListnerに登録するとScrollDetector中のthisが変わってしまうので一つ関数を経由する
    this.scrollDetector.nowScrolling();
  }

  getChildVueComponent():PublicPageVue|null{
    switch(this.publicPageData.layout){
      case PublicPageLayout.PLAIN:
        return this.empty;
      case PublicPageLayout.STANDARD:
        return this.standard;
      default:
        return null;
    }
  }

  onMessage(e:MessageEvent){
    this.afterLoadLauncher.runFunction(()=>{
      if(this.notFound){
        return;
      }
      const child = this.getChildVueComponent();
      //projectページ->他ページと画面遷移する瞬間に、レイアウト変更通知がiframeから来ると、getChildVueComponent()がnullになる。
      if(!child){
        if (process.env.VUE_APP_MODE === "development")console.log("公開ページ破棄後にiframeからのメッセージを受け取りました。", e);
        return;
      }
      const dataType = e && e.data && (e.data as ForkstyleMessages).type;
      
      switch(dataType){
        case 'forkstyle-message-initialized':
          child.onViewInitialized(e.data)
          break;
        case 'forkstyle-message-size':
          if(e.data.isResponse){
            //子iframeにサイズ要求中に再度サイズ要求タイミングがきて、待たせていた場合
            if(this.sizeRequestedCount >= 2){
              this.sizeRequestedCount = 0;
              child.onViewSizeChanged(e.data)
              //todo:なぜもう一度送信するんだろ…。windowサイズを変更 -> iframeサイズ変更 -> 内部サイズ変更 -> 親サイズ変更と相互関係はあるが…
              //レイアウトによって、親 -> 子と決まるレイアウトと、子 -> 親と決まるレイアウトがあるため、その両方を対応しようとしている？？
              this.requestSize();
            }else{
              this.sizeRequestedCount = 0;
              child.onViewSizeChanged(e.data)
            }
          }else{
            child.onViewSizeChanged(e.data)
          }
          break;
        case "forkstyle-message-not-found":
          child.onViewNotFound()
          break;
        case "forkstyle-message-comment-from-creator":
          child.onCommentFromCreator(e.data)
          break;     
        case "forkstyle-message-comment-write-condition-changed":
          child.onCommentWriteConditionChanged(e.data)
          break;
        case 'forkstyle-message-comment-load-condition-changed':
          child.onCommentLoadConditionChanged(e.data)
          break;
        case "forkstyle-message-login-request":
          this.onRequestLogin(e.data)
          break;
        case "forkstyle-message-scroll-to":
          this.onScrollTo(e.data)
          break;
        case "forkstyle-message-set-layout":
          this.onSetLayout(e.data)
          break;
        case "forkstyle-message-event-listener-added":
          this.onEventListenerAdded(e.data)
          break;
        case "forkstyle-message-go-back":
          routeState.goBackUI();
          break;
        default:
          if (process.env.VUE_APP_MODE === "development")console.log("想定外のメッセージ", e);
          break;
      }
    })
  }
  
  onRequestLogin(data:FMRequestLogin){
    if(this.$root.account.isLogin){
      if (process.env.VUE_APP_MODE === "development")console.log("ログイン済みの状態でログイン要求がviewより来ました")
    }else{
      this.$root.loginDialog.open(data)
    }
  }
  onSetLayout(data:FMSetLayout){
    this.viewLayoutRequest = data;
    this.$root.commonHeader.setBackground(data)
  }

  onEventListenerAdded(data:FMEventListenerAdded){
    const child = this.getChildVueComponent();
    //projectページ->他ページと画面遷移する瞬間に、サイズ変更すると、getChildVueComponent()がnullになる。
    if(!child){
      return;
    }
    registerEventSend(child.getIframe(), data);
  }

  
  onScrollTo(data:FMScrollTo){
    //[duplicated] KIWI側（API）でもだいたい同じようなサニタイズをしている
    switch(data.arguments["length"]){
      case 1:
          //今後のJS仕様の変更に対応するため、余計なプロパティが渡されないようにオブジェクトの作り直し
          var option = {
            "top": data.arguments[0].top, 
            "left": data.arguments[0].left, 
            "behavior": data.arguments[0].behavior
          };
          window.scrollTo(option);
          break;
      case 2:
          window.scrollTo(Number(data.arguments[0]), Number(data.arguments[1]));
      break;
    }
  }

  initPublicPage(publicPage: PublicPageResp){
    this.publicPageData = publicPage
    if(!this.isPreview){
      this.countUpVisited();
    }
    this.afterLoadLauncher.clearStopper("PROJECT LOADED")
  }
  
  created(){
    //kiwiのiframeからの通知を受けれるようにする
    window.addEventListener('message',this.onMessage);
    window.addEventListener("resize", this.requestSize);
    window.addEventListener("scroll", this.nowScrolling);
    
    startWakeLock();
    
    this.$root.restAccess.postStatistics("public-page")
    document.title = this.$route.params?.publicPageTitle?.toString();

    this.prevWidth = this.$root.common.getWindowWidth();
    this.prevHeight = this.$root.common.getWindowHeight();

    if(this.isPreview){
      this.showPreview()
    }else{
      this.showPublicPage()
    }


  }
  
  mounted(){
    this.$root.hideFooter();
  }
  beforeUnmount(){
    this.$root.showFooter();

    clearEventSend();

    //kiwiのiframeと連携用登録を削除する
    window.removeEventListener('message', this.onMessage);
    window.removeEventListener("resize", this.requestSize)
    window.removeEventListener("scroll", this.nowScrolling);
    
    endWakeLock();

    this.$root.commonHeader.clearBackground();
    if(this.isPreview){
      this.$root.account.removeLoginListener(this.showPreview)
    }
  }
}
</script>
<style lang="scss" scoped>
.projectTop{
  transition: background-color 3s;
}
</style>

